import {
  ENTITY_ICON,
  entityTone,
  type KnownEntityType,
} from '@/features/document-overlay/entity-tone'

export function EntityChip({ label }: { label: string }) {
  const tone = entityTone(label)
  const icon = ENTITY_ICON[label as KnownEntityType]
  return (
    <span
      // Phone: a very long type name is cut with an ellipsis instead of pushing
      // the group's count out of the accordion header.
      className="max-md:min-w-0"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: '9999px',
        background: tone.bg,
        color: tone.color,
        border: `1px solid ${tone.border}`,
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      {icon}
      <span className="max-md:truncate">{label}</span>
    </span>
  )
}
